import React from 'react';
import { Sparkles } from 'lucide-react';
import { useT } from '../i18n/LanguageContext';

export default function SloganBanner() {
  const { t } = useT();
  return (
    <section className="relative py-10 bg-[#4dbfae] overflow-hidden">
      <div className="absolute -left-8 top-4 w-24 h-24 rounded-full bg-white/10" />
      <div className="absolute right-10 bottom-2 w-32 h-32 rounded-full bg-white/10" />
      <div className="absolute left-1/3 top-1/2 w-16 h-16 rounded-full bg-white/10" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-center gap-4 text-center">
        <Sparkles size={28} className="text-white hidden sm:block" />
        <p className="font-serif text-white text-2xl md:text-4xl font-bold tracking-wide">
          {t('slogan')}
        </p>
        <Sparkles size={28} className="text-white hidden sm:block" />
      </div>
    </section>
  );
}
